import { Progress } from "~/atoms/progress";

interface WorkflowProgressValue {
  completedSteps: number;
  totalSteps: number;
}

interface WorkflowProgressProps {
  workflow?: WorkflowProgressValue | null;
  completedSteps?: number;
  totalSteps?: number;
}

const resolveWorkflowProgress = ({
  workflow,
  completedSteps,
  totalSteps,
}: WorkflowProgressProps): WorkflowProgressValue | null => {
  if (workflow) {
    return workflow;
  }

  if (completedSteps === undefined || totalSteps === undefined) {
    return null;
  }

  return { completedSteps, totalSteps };
};

export const WorkflowProgress = (props: WorkflowProgressProps) => {
  const progress = resolveWorkflowProgress(props);
  if (!progress || progress.totalSteps <= 0) {
    return null;
  }

  const percentage = (progress.completedSteps / progress.totalSteps) * 100;

  return (
    <div className="flex items-center gap-2">
      <Progress value={percentage} />
      <span className="text-muted-foreground text-sm">
        {progress.completedSteps}/{progress.totalSteps}
      </span>
    </div>
  );
};
